module.exports = __webpack_public_path__ + "img/Greg White.11993bca.jpg";